"use client";

export default function StatsSection() {
  const stats = [
    { value: "$149", label: "Board-Up Starts" },
    { value: "Same-Day", label: "Emergency Response" },
    { value: "30-Day", label: "Workmanship Guarantee" },
    { value: "12", label: "Miami-Dade Areas" },
  ];

  return (
    <section className="bg-primary text-white py-10 px-4 md:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {stats.map((s) => (
          <div key={s.label} className="text-center">
            <p className="text-2xl md:text-3xl font-bold">{s.value}</p>
            <p className="text-sm text-white/80 mt-1">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}